import { render, staticRenderFns } from "./request_show.vue?vue&type=template&id=289b2d43"
import script from "./request_show.vue?vue&type=script&lang=js"
export * from "./request_show.vue?vue&type=script&lang=js"
import style0 from "./request_show.vue?vue&type=style&index=0&id=289b2d43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports